/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';

import PropTypes from 'prop-types';

import styles from '../../css/breadcrumbs.module.css';


const BreadcrumbState = ({
    Initial: () => ({}),
    Actions: () => ({})
});


const Crumb = ({ name, url }) => (
    <>
        <li>
            {url === null || url.length === 0
                ? <div>{name}</div>
                : <>
                    <a href={url}><div>{name}</div></a>
                    <span aria-hidden="true"> / </span>
                </>
            }
        </li>
    </>
);

Crumb.defaultProps = { url: '' };

Crumb.propTypes = { name: PropTypes.string.isRequired, url: PropTypes.string };


const BreadcrumbComponent = ({ crumbs }) => (
    <div className={styles.breadcrumbs}>
        <span>
            <ul>
                {crumbs.map(({ name, url }) => (
                    <Crumb key={`${name}${url}`}
                        name={name}
                        url={url}
                    />
                ))}
            </ul>
        </span>
    </div>
);

BreadcrumbComponent.propTypes = (
    { crumbs: PropTypes.arrayOf(PropTypes.shape(Crumb.propTypes)).isRequired }
);


export default {
    State: BreadcrumbState,
    Component: BreadcrumbComponent
};
